import axiosPost from "./axiosPost";

export const RNHHospitalGet = async (credentials, data) => {
    const body = {
        service: "RNHHospitalGet",
        params: {
            rnhHospitalId: data?.id || null,
            rnhAreaId: data?.areaId || null,
            rnhZonaId: data?.zonaId || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
